import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { Sparkles } from "lucide-react";

const PincodeObserver = () => {
  const { values, setFieldValue } = useFormikContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check if pincode exists and is exactly 6 digits
    if (values.pincode && values.pincode.length === 6) {
      const fetchAddress = async () => {
        setLoading(true);
        try {
          const res = await fetch(`https://goelectronix.in/api/v1/pincode/${values.pincode}`);
          const result = await res.json();
          if (result.success) {
            setFieldValue("state", result?.state || "");
            setFieldValue("district", result?.district || "");
          }
        } catch (err) {
          console.error("Pincode fetch error:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchAddress();
    } 
    // ✅ NEW LOGIC: Clear fields if pincode is empty or incomplete
    else if (!values.pincode || values.pincode.length < 6) {
      // Only clear if they aren't already empty to avoid unnecessary re-renders
      if (values.state !== "" || values.district !== "") {
        setFieldValue("state", "");
        setFieldValue("district", "");
      }
    }
  }, [values.pincode, values.state, values.district, setFieldValue]);

  if (!loading) return null;

  return (
    <div className="absolute right-6 top-10 flex items-center gap-2 text-emerald-500 animate-in fade-in">
      <span className="text-[9px] font-black uppercase tracking-tighter">Locating...</span>
      <Sparkles size={14} className="animate-spin" />
    </div>
  );
};

export default PincodeObserver;